var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{staticClass:"player-rating",attrs:{"is-vertical":""},scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_c('div',{staticClass:"player-rating__tooltip"},[_vm._v(_vm._s(_vm.$t('ratingVVVTooltip')))])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }